interface IStyledSafeAreaViewProps {
	children: React.ReactNode
}

export const ScreenContainer = ({ children }: IStyledSafeAreaViewProps) => {
	// return <div className="h-screen w-screen bg-[#000000] p-[10px] pb-[40px]">{children}</div>
	return <div className="min-h-screen bg-[#000000] p-[10px] pb-[40px]">{children}</div>
}
